export default __webpack_public_path__ + "static/media/brushIcon.421d2f77.webp";